import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwpg89gmw3: FaireProductEntity = {
  token: "p_qwpg89gmw3",
  type: "product",
  name: "Sweetgrass Twisted Rim Basket",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/71e1f2d23015fbf77b12e56f2a1e92083205bda67343ac429c2e58b4a6c6c68f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f93f1684cf22d83510d9b571c79bb403d5c5b128ae982571b35fcf71b91149a.jpeg",
    "https://cdn.faire.com/fastly/31e78098f72a4488d2b462c024d9c1a9f923811ae930be3d5d08c9bcd4bf0c11.jpeg",
    "https://cdn.faire.com/fastly/34431b31965a9f2979f4d7ff77e9c200cb479a41e12f86e2dc219071da27fbd2.jpeg",
    "https://cdn.faire.com/fastly/004dbc531a1257593615ac6135864ae34aadd7916ae4541941e5015555f4ee42.jpeg"
  ],
  priceDollars: 10,
  description: "Small: 6\" wide\nLarge: 10\" wide\n\nThese woven baskets are handmade in Rwanda, using locally grown sweetgrass. It is a beautiful display piece and catchall for your entryway or coffee table. Crafted using natural sweetgrass and marsh grass, the variations in tones make this basket an earthy, one-of-a-kind piece.\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:19.637Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
